import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DraftListItemComponent } from './draft-list-item.component';
import { WidgetsModule } from '../../widgets/widgets.module';
import { TooltipModule } from '@progress/kendo-angular-tooltip';

@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
        TooltipModule
    ],
    declarations: [
        DraftListItemComponent,
    ],
    exports: [
        DraftListItemComponent,
    ],
    providers: []
})
export class DraftListItemModule {

}
